import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from '../modules/layout-shared/confirmation-modal/confirmation-modal.component';

export interface DismissModalParams {
  message: string;
  subMessage: string;
  confirmLabel: string;
}

@Injectable({
  providedIn: 'root',
})
export class DismissModalHelperService {
  private hasChanges = false;
  constructor(private modalService: NgbModal) {}

  setHasChanges(hasChanges: boolean) {
    this.hasChanges = hasChanges;
  }

  getHasChanges() {
    return this.hasChanges;
  }

  openModal(params: DismissModalParams) {
    const dismissModal = this.modalService.open(ConfirmationModalComponent);

    dismissModal.componentInstance.modalProps = {
      title: '',
      message: params.message,
      subMessage: params.subMessage,
      icon: 'fa-file-edit',
      buttons: [
        {
          text: params.confirmLabel,
          style: 'btn btn-primary',
          action: () => dismissModal.close(true)
        },
        {
          text: 'Cancel',
          style: 'btn btn-outline-dark',
          action: () => dismissModal.close(false)
        }
      ]
    };

    return dismissModal.result;
  }
}
